import ScopeConstants from "constants/ScopeConstants"

export const CostCodeGroupScope = {
    key: ScopeConstants.COST_CODE_GROUP,
    selector: (state) => state.costCodeGroups,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/CostCodeGroup/Search/",
    singleEndpoint: "/api/CostCodeGroup/Get/",
    updateEndpoint: "/api/CostCodeGroup/Update/",
    deleteEndpoint: "/api/CostCodeGroup/Delete/",
    defaultRecord: {
        name: "",
        description: ""
    }
}